module.exports = __webpack_public_path__ + "img/cost_icon_14.4a4d4aee.svg";